import React from 'react';

const formatEuroPrice = (value) => {
  if (value === undefined || value === null) return '';
  const numeric = Number(value);
  if (Number.isNaN(numeric)) return '';
  return `€${numeric.toFixed(2).replace(/\.00$/, '')}`;
};

// Презентационен компонент: списъкът с услуги (с точните цени за
// избраните бръснар + локация) идва от родителя, който го зарежда от
// GET /api/services?locationId=&barberId=.
function ServicesSelect({ services, selectedService, setSelectedService, loading, error, className }) {
  if (loading) return <p className={className}>Зареждане на услугите...</p>;
  if (error) return <p className={className}>{error}</p>;

  return (
    <select
      value={selectedService}
      className={`border border-red-800 bg-neutral-100 rounded-lg p-2 transition duration-300 hover:shadow-lg focus:shadow-outline ${className || 'w-full'}`}
      onChange={(e) => setSelectedService(e.target.value)}
    >
      {services.map((service) => {
        const labelPrice = formatEuroPrice(service.price);
        return (
          <option key={service.id} value={service.id}>
            {labelPrice ? `${service.name} - ${labelPrice}` : service.name}
          </option>
        );
      })}
    </select>
  );
}

export default ServicesSelect;
